export default class TermostatProductLists {
  pro2: string[] = []
  tech: string[] = []
  heatmiser: string[] = []
  techAccessory: string[] = []
  techWirelessAccessory: string[] = []
}
